import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import Loading from '../../../bronson/Loading';

function ListadoFiltro(props) {
    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState('');
    const [selectedContract, setSelectedContract] = useState(
        props.selectedContract
    );

    const showList = () => {
        setIsOpen(true);
    };

    const hideList = () => {
        setIsOpen(false);
    };

    const handleFilterChange = e => {
        setFilter(e.target.value);
    };

    const changeSelect = value => {
        setSelectedContract(value);
        props.selectedContract = value;
    };

    const filteredItems = props.items?.filter(item =>
        filter != ''
            ? item.operation_code.toLowerCase().includes(filter.toLowerCase())
            : item
    );

    return (
        <React.Fragment>
            <div class="o-layout__item u-1/1">
                <div className="c-custom-select">
                    <div className="c-input">
                        <input
                            className="c-input__input  "
                            autoComplete="off"
                            type="text"
                            placeholder="Seleccione un contrato"
                            /*onBlur={hideList}*/ onFocus={showList}
                            value={selectedContract}
                            onChange={handleFilterChange}
                        />
                        <button
                            className={`c-input__addon  c-input__addon--no-background u-pl-none u-pr-none`}
                            style={{ cursor: 'context-menu' }}
                        >
                            <i className="c-icon  c-icon--[semantic-search]"></i>
                        </button>
                    </div>
                </div>
                <div
                    className="c-custom-select"
                    style={{
                        display: 'block',
                        minHeight: '250px',
                        maxHeight: '250px',
                        overflowY: 'scroll',
                    }}
                >
                    <ul
                        id="ul_bronson"
                        className="c-custom-select__dropdown"
                        style={{ display: !isOpen ? 'none' : 'contents' }}
                    >
                        {filteredItems.length !== 0 || filter !== ''
                            ? filteredItems.map((contract, index) => {
                                  return (
                                      <li
                                          id={'li_bronson_' + index}
                                          key={contract.operation_code}
                                          className={
                                              'c-custom-select__item  ' +
                                              (contract.operation_code == filter
                                                  ? 'is-active'
                                                  : '')
                                          }
                                          onClick={() =>
                                              changeSelect(
                                                  contract.operation_code
                                              )
                                          }
                                      >
                                          {'Contrato: ' +
                                              contract.operation_code +
                                              ' - ' +
                                              contract.propduct_type +
                                              ' - Nº Vehículos: ' +
                                              contract.cars_quantity +
                                              ' - Cuota: ' +
                                              contract.nextAmount}
                                      </li>
                                  );
                              })
                            : props.items.map((contract, index) => {
                                  return (
                                      <li
                                          id={'li_bronson_' + index}
                                          key={contract.operation_code}
                                          className={
                                              'c-custom-select__item  ' +
                                              (contract.operation_code == filter
                                                  ? 'is-active'
                                                  : '')
                                          }
                                          onClick={() =>
                                              changeSelect(
                                                  contract.operation_code
                                              )
                                          }
                                      >
                                          {'Contrato: ' +
                                              contract.operation_code +
                                              ' - ' +
                                              contract.propduct_type +
                                              ' - Nº Vehículos: ' +
                                              contract.cars_quantity +
                                              ' - Cuota: ' +
                                              contract.nextAmount}
                                      </li>
                                  );
                              })}
                    </ul>
                </div>
                <div class="o-layout__item u-1/1"></div>
            </div>
        </React.Fragment>
    );
}

export default withRouter(ListadoFiltro);
// {
//     isOpen && filteredItems && filteredItems.map(
//         contract => (
//             <option
//                 key={
//                     contract.operation_code
//                 }
//                 value={
//                     contract.operation_code
//                 }
//             >
//                 {'Contrato: ' +
//                     contract.operation_code +
//                     ' - ' +
//                     contract.propduct_type +
//                     ' - Nº Vehículos: ' +
//                     contract.cars_quantity +
//                     ' - Cuota: ' +
//                     contract.nextAmount}
//             </option>
//         )
//     )
// }
{
    /* <div className="c-custom-select" ref={wrapperRef}>
                <div className="c-input">
                    <input
                        // onBlur={onFocusOut}
                        // onKeyPress={e => onKeyPress(e)}
                        onFocus={toggleList}
                        onClick = { toggleList }
                        onChange={handleFilterChange}
                        disabled={options.disabled}
                        autoComplete="off"
                        value={inputValue}
                        className="c-input__input  "
                        id={'ListadoFiltroPropias'}
                        type="text"
                        placeholder = "Seleccione un contrato"
                    />
                    <button
                        className={`c-input__addon  c-input__addon--no-background u-pl-none u-pr-none ${
                            options.disabled ? '__class_noMagnifying' : ''
                        }`}
                        style={{ cursor: 'context-menu' }}
                    >
                        <i className="c-icon  c-icon--[semantic-search]"></i>
                    </button>
                </div>

                <ul
                    id="ul_bronson"
                    className="c-custom-select__dropdown"
                    style={{ display: !isOpen ? 'none' : 'inline' }}
                >
                    {filteredItems.length !== 0 ? (
                        filteredItems.map((valueOption, index) => {
                            return (
                                <li
                                    id={'li_bronson_' + index}
                                    key={valueOption.operation_code}
                                    className={
                                        'c-custom-select__item  ' +
                                        (valueOption.operation_code == filter
                                            ? 'is-active'
                                            : '')
                                    }
                                    //(valueOption)
                                    onClick={() => handleFilterChange}
                                >
                                    { {valueOption[textDisplay]} }
                                </li>
                            );
                        })
                    ) : options.loading ? (
                        <li
                            id="li_bronson_0"
                            className="c-custom-select__item  "
                        >
                            <Loader />
                        </li>
                    ) : (
                        <li
                            id="li_bronson_0"
                            className="c-custom-select__item  "
                        >
                            {options.default}
                        </li>
                    )}
                </ul>
            </div> */
}

{
    /* {
                    listContracts.map((contract, index) => {
                        return (
                            <li
                                id={'li_bronson_' + index}
                                key={contract.operation_code}
                                className={
                                    'c-custom-select__item  ' +
                                    (contract.operation_code == filter
                                        ? 'is-active'
                                        : '')
                                }
                                // onClick={() => onChangeSelect(contract.operation_code)}
                            >
                                {'Contrato: ' +
                                    contract.operation_code +
                                    ' - ' +
                                    contract.propduct_type +
                                    ' - Nº Vehículos: ' +
                                    contract.cars_quantity +
                                    ' - Cuota: ' +
                                    contract.nextAmount
                                }
                            </li>
                        )
                    })
                } */
}
